// extracted by mini-css-extract-plugin
module.exports = {"Main":"PlayerButton__Main__3M5Pd"};